import {normalizeProductPickerItem} from './modeStorage';
import {ProductPickerItem} from './types';

export const needsProductDetails = (product: ProductPickerItem): boolean =>
    Boolean(product.has_variation)
    && (!product.variations_combinations || product.variations_combinations.length === 0);

export const willFetchProductDetails = (
    product: ProductPickerItem,
    fetchProductDetails?: (productId: number) => Promise<ProductPickerItem | null>,
    options?: {force?: boolean},
): boolean =>
    Boolean(fetchProductDetails) && (Boolean(options?.force) || needsProductDetails(product));

export const resolveProductDetails = async (
    product: ProductPickerItem,
    fetchProductDetails?: (productId: number) => Promise<ProductPickerItem | null>,
    options?: {force?: boolean},
): Promise<ProductPickerItem> => {
    const shouldFetch = willFetchProductDetails(product, fetchProductDetails, options);
    if (!shouldFetch || !fetchProductDetails) {
        return product;
    }

    try {
        const detailed = await fetchProductDetails(product.id);
        if (!detailed) {
            return product;
        }
        return normalizeProductPickerItem({
            ...product.raw,
            ...detailed.raw,
            ...detailed,
            id: product.id,
        });
    } catch {
        return product;
    }
};
